export enum AssetDepreciationType {
AccountingBase,
TaxBase,
}
